import React from 'react';
import PropTypes from 'prop-types';
import { ProminentLabel } from 'web-ui-components/lib/typography/labels';
import AccountDropDownComponent from '../payment-fate/AccountDropDownComponent';
import StringConstants from '../../constants/StringConstants';

export const ManagePaymentsSMEDropDown = ({ label, dropDownProps }) => (
  <div>
    <ProminentLabel>{label}</ProminentLabel>
    <AccountDropDownComponent
      {...dropDownProps}
      selectedAccount={
        dropDownProps.selectedAccount
          ? dropDownProps.selectedAccount
          : StringConstants.ALL
      }
    />
  </div>
);

ManagePaymentsSMEDropDown.propTypes = {
  dropDownProps: PropTypes.shape({
    selectedAccount: PropTypes.object,
    onDropdownSelect: PropTypes.func.isRequired,
    accountList: PropTypes.array.isRequired,
  }),
  label: PropTypes.string.isRequired,
};

export default ManagePaymentsSMEDropDown;
